<template>
    <div class="px-3 pb-3 pt-1 bg-light border mb-3">
        <div class="d-flex date-bar mt-2">
          <button 
          :disabled="disableComponent" 
          :style="buttonColor?`backgroundColor: ${buttonColor} !important`:''" 
          class="h-100 my-auto darker-hover rounded-left" 
          @click="()=>parentPointsPerDay('prev')">
            <span class="d-none d-sm-flex">Prev</span>
            <span class="d-sm-none">⮜</span>
          </button>
          <b-form-datepicker
            v-model="calendarValue"
            class=""
            size="sm"
            placeholder="Choose a date"
            :disabled="disableComponent"
            :date-format-options="{
              year: 'numeric',
              month: 'short',
              day: '2-digit',
              weekday: 'short'
            }"
            locale="en"
            :date-disabled-fn="dateDisabled"
          ></b-form-datepicker>
          <button 
          :disabled="disableComponent||validateNextDate" 
          :style="buttonColor?`backgroundColor: ${buttonColor} !important`:''" 
          class="h-100 my-auto darker-hover rounded-right" 
          @click="()=>parentPointsPerDay('next')">
            <span class="d-none d-sm-flex">Next</span>
            <span class="d-sm-none">⮞</span>
          </button>
        </div>
    </div>
</template>

<script>

export default ({
    props:{
        disableComponent:{
            type:Boolean,
            default:false
        },
        dateDisabled:{
            type:Function,
            default:()=>{}
        },
        setValue:{
            type:Function,
            default:()=>{}
        },
        weekly: {
            type:Boolean,
            default:false
        },
        buttonColor: {
            type:String,
            default:''
        }
    },
     watch: {
         
        calendarValue: function(){
            this.setValue(this.calendarValue)
        }
    },
    data() {
        return {
            calendarValue: ''
        } 
    },
    methods:{
        parentPointsPerDay(action){
            let today = new Date();
            let currentDate = this.calendarValue?new Date(this.calendarValue):new Date();  
            let finalDate = currentDate

            if(action=='prev'){
                finalDate.setDate(currentDate.getDate()-(this.weekly?7:1))
            }
            if(action=='next'){
                finalDate.setDate(currentDate.getDate()+(this.weekly?7:1))
                if (finalDate>today) {
                    finalDate=today
                } 
            }

            this.calendarValue = `${finalDate.getUTCFullYear()}-${finalDate.getUTCMonth()+1}-${finalDate.getUTCDate()}`
        },
        
    },
    computed:{
        validateNextDate(){
            if (this.calendarValue) {
                const currentDate = new Date(this.calendarValue)
                const today = new Date()
                const month = today.getUTCMonth() <= currentDate.getUTCMonth()
                const day = today.getUTCDate() <= currentDate.getUTCDate()
                const year = today.getUTCFullYear() <= currentDate.getUTCFullYear()
                return (this.calendarValue&&year&&day&&month)
            } else {
                return true
            }
        },
    }
})
</script>


<style scoped lang="scss">
.date-bar{
  gap: 1rem;

  button{
    outline: none;
    width: 60px !important;
    height: 35px !important;
    border: none;
    background-color: var(--color-main);
    color: #ffffff;
    cursor: pointer;
  }
  
  button:disabled{
    opacity: 0.5;
  }

}
</style>